import { DISMISS_NOTIFICATION } from './action-types';


export function dismissNotification() {
  return {
    type: DISMISS_NOTIFICATION
  };
}
